import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_PORTFOLIO_DETAIL_API =
  'INVESTMENT/FETCH_PORTFOLIO_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PORTFOLIO_DETAIL_API,
  ({ user_id, ...params }: { user_id: string }) => ({
    endpoint: generateEndpoint({
      host: '/api/admin/portfolios',
      params: { user_id, ...params },
    }),
    method: 'GET',
  })
);

export default apiCall;
